import React from 'react'
import styled from 'styled-components'
import busImage from '../../../../../assets/img/item_service.png'
import { device } from '../../../../../config/theme/breakpoints'

const ContainerDetail = styled.div`
    background: #F2F2F2;
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    border-radius: 15px;
    margin-left: 10px;
    margin-bottom: 10px;

    @media ${device.tablet}{
        width: 46%;
    }
    
    @media ${device.laptop}{
        width: 32%;
    }
`

const ContainerImage = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    > img {
        width: 100%;
        border-radius: 10px 10px 100px 10px;
        width 100%;
        margin: auto;
    }
`
const ContainerText = styled.div`
    padding: 20px;

    > h4 {
        color: ${p => p.theme.palette.primary.main}
    }
`

const ItemDetailAbout: React.FunctionComponent = () => {

  return (
    <ContainerDetail>
        <ContainerImage>
            <img src={busImage} alt='imagen de bus'/>
        </ContainerImage>
        <ContainerText>
            <h4>Valores</h4>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
        </ContainerText>
    </ContainerDetail>
  )
}

export default ItemDetailAbout